(function($) {
    var windowWidth = parseInt(window.innerWidth);
    var hamWidth = 1360;
    var spWidth = 768;
    var tabletWidth = 1024;
    var hamState = false;
    var hamPos;
    var grayOffset;
    var scrollStock;
    var scrollbarWidth = window.innerWidth - $(window).width();

    // modal
    MicroModal.init({
        disableScroll: true,
        // iOS背景スクロール対策
        onShow: modal => {
            //console.log(scrollbarWidth);
            $('body').css('padding-right', scrollbarWidth+ 'px');
            if(windowWidth < spWidth) {
                scrollStock = $(window).scrollTop();
                $('body').css('top', -scrollStock + 'px');
                $('html, body').addClass('modal-open');
            }
        },
        onClose: modal => {
            $('body').css('padding-right', '');
            if(windowWidth < spWidth) {
                $('html, body').removeClass('modal-open');
                $('body').css('top', '0px');
                window.scrollTo(0, scrollStock);
            }
        }
    });

    // showmore
    if (windowWidth < spWidth) {
        var showmoreHeight = '1266px'; // 210 * 6 + 6px border分を追加（safari）
    } else if (windowWidth < tabletWidth) {
        var showmoreHeight = '813px'; // 270 * 3 + 3px
    } else {
        var showmoreHeight = '542px'; // 270 * 2 + 2px
    }
    //console.log(showmoreHeight);

    $('.inner-lc-result').showMore({
        speedDown: 300,
        speedUp: 300,
        height: showmoreHeight,
        showText: 'View more',
        hideText: 'Close'
    });

    // loading
    $(function() {
        $('.wrap').css('display','none');
    });

    // form
    // selectにrequiredを付与
    $('.mw_wp_form select').each(function() {
        //$(this).attr('required', true);
        if ($(this).val() == 0) {
            $(this).css('color', 'rgba(43, 43, 43, 0.4)');
        }
    });

    // other項目をdisble
    $('.mw_wp_form select.select_other').each(function() {
        if ($(this).val() == 'その他') {
            $('.mw_wp_form #'+$(this).attr('id') +'_other').prop("disabled", false);
        } else {
            $('.mw_wp_form #'+$(this).attr('id') +'_other').prop("disabled", true);
        }
    });

    // プライバシーポリシー置換
    $('.mw_wp_form input.pp_check').next().html('<a target="_blank" href="/privacy-policy/">プライバシーポリシー</a>に同意する');

    $(window).on('load',function(){
        $(".load-anime").delay(600).fadeOut('slow');
        $(".load").delay(1000).fadeOut('slow').promise().done(function() {
            //console.log('loadfade開始');
            $('body').addClass('appear');
            $('.wrap').css('display','block');

            // scrollhint
            if (windowWidth < spWidth) {
                new ScrollHint('.js-scrollable', {
                    i18n: {
                        scrollable: 'scroll'
                    }
                });
            }

            // midnight
            if(windowWidth > hamWidth) {
                $('header.midnight').midnight();
            }

            // accordion
            $('.item-qa__a').css('display','none');

            // ローディングフェード終了時間に合わせる。ロードアニメーションはCSS制御の為。
            setTimeout(function(){
                 fadeAnime();
            },1000);

            // 背景変化
            if ($('[data-midnight="gray"]').length) {
                grayOffset = $('[data-midnight="gray"] .head-com').offset().top + $('[data-midnight="gray"] .head-com').outerHeight();
            }

            $('[data-midnight="gray"], .midnightHeader.gray').addClass('init-mid');

            // pagerのゼロパディング
            if ($('.wp-pagenavi').length) {
                $('.wp-pagenavi > a, .wp-pagenavi > span').each(function() {
                    var navValue = $(this).text();
                    //console.log($.isNumeric(navValue));
                    if ($.isNumeric(navValue)) {
                        //console.log(navValue);
                        $(this).text(String(navValue).padStart(2, '0'));
                    }
                });
            }

            // エラーの位置まで移動
            if ( $('.mw_wp_form .error')[0] ) {
                var error_id = $('.mw_wp_form .error').prev().attr('id');
                //console.log(error_id);
                if ($('label[label-for="' +error_id +'"]').length) {
                    var position = $('label[label-for="' +error_id +'"]').offset().top;
                } else {
                    var position = $('.mw_wp_form .error').offset().top - 50;
                }
                $('body,html').animate({scrollTop:position}, 600, 'swing');
            }

            // swiper
            const mySwiper = new Swiper('.swiper', {
                slidesPerView: 'auto',
                spaceBetween: 20,
                grabCursor: true,
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: false,
                    draggable: true,
                },
                //simulateTouch: false,
            });
        });
    });

    // menu
    $('.menu-btn').on('click', function(){
        $('.gnav-wrap, .menu-btn').toggleClass('is-active');
        if (hamState == false) {
            hamPos = $(window).scrollTop();
            $('body').addClass('fixed').css({'top': -hamPos});
            hamState = true;
        } else {
            $('body').removeClass('fixed').css({'top': 0});
            window.scrollTo(0, hamPos);
            hamState = false;
        }
    });

    //tab
    $('.tab-btn').on("click", function() {
        var targetId = $(this).attr('target-id');
        $('.tab-btn-wrap .active').removeClass('active');
        $(this).addClass('active');
        $('.tab-content-wrap .show').removeClass('show');
        $('.tab-content-wrap #' +targetId).addClass('show');
    });

    // accordion
    $(".item-qa__q").on("click", function() {
        $(this).toggleClass('active');
        $(this).next('.item-qa__a').toggleClass('open');
        $(this).next('.item-qa__a').slideToggle();
    });

    // page-top
    $(function() {
        var appear = false;
        var pagetop = $('.page-top');
        var windowHeight = $(window).height();

        $(window).scroll(function() {
            let scrollTop = $(window).scrollTop();
            var scrollHeight = $(window).scrollTop() + $(window).height(); //ページトップから現在の画面下部までの高さ
            var footer = $("footer").offset().top;

            if ($(this).scrollTop() > windowHeight) {
                if (appear == false) {
                    appear = true;
                    pagetop.stop().animate({
                        'bottom': '0px'
                    }, 300);
                } else {
                    // footerに到達したら、pagetopのfixed解除
                    if (scrollHeight > footer) {
                        pagetop.css({'position':'absolute', 'top':'0px', 'bottom':'initial'});
                    } else {
                        pagetop.css({'position':'fixed', 'top':'initial', 'bottom':'0px'});
                    }
                }
            } else {
                if (appear) {
                    appear = false;
                    pagetop.stop().animate({
                        'bottom': '-180px'
                    }, 300);
                }
            }
        });
        pagetop.click(function() {
            $('body, html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    });

    // animation
    function fadeAnime(){
        var scroll = $(window).scrollTop();
        var docHeight = $(document).height();
        var windowHeight = $(window).height();

    	$('.fadeUpTrigger').each(function() {
            var elemPos = $(this).offset().top-50;

            if (scroll >= elemPos - windowHeight){
                if ($(this).hasClass('footer-sns')) {
                    $(this).addClass('fadeUpFooter');
                } else {
                    $(this).addClass('fadeUp');
                }
                $(this).addClass('fadeUp');
            } else {
                $(this).removeClass('fadeUp fadeUpFooter');
            }
        });

        $('.fadeUpFvTrigger').each(function() {
            var elemPos = $(this).offset().top-50;
            if (scroll >= elemPos - windowHeight){
                $(this).addClass('fadeUpFv');
            }
        });
    }

    // gnav button hover
    $('.item-to-b-contact a')
        .mouseover(function(e) {
            $('.item-to-b-contact a').addClass('hover');
        })
        .mouseout(function(e) {
            $('.item-to-b-contact a').removeClass('hover');
        });
    $('.item-to-c-contact a')
        .mouseover(function(e) {
            $('.item-to-c-contact a').addClass('hover');
        })
        .mouseout(function(e) {
            $('.item-to-c-contact a').removeClass('hover');
        });

    $(window).on('scroll', function (){
        // 初期時アニメーションされるのを防ぐ
        if ($(this).scrollTop() != 0) {
            fadeAnime();
        }

        // gray背景を要素到達後に変化
        if ($(window).scrollTop() + $(window).height() > grayOffset) {
            $('[data-midnight="gray"], .midnightHeader.gray').removeClass('init-mid');
            $('[data-midnight="gray"], .midnightHeader.gray').addClass('disp-mid');
        }
    });

    // form その他、選択時
    $(function() {
        $('.mw_wp_form select.select_other').change(function() {
            if ($(this).val() == 'その他') {
                $('.mw_wp_form #'+$(this).attr('id') +'_other').prop("disabled", false);
            } else {
                $('.mw_wp_form #'+$(this).attr('id') +'_other').prop("disabled", true);
            }
        });

        $('.mw_wp_form select').change(function() {
            if ($(this).val() == 0) {
                $(this).css('color', 'rgba(43, 43, 43, 0.4)');
            } else {
                $(this).css('color', '#2b2b2b');
            }
        });
    });

    // wp_pagenavi
    if ($('.wp-pagenavi').length) {
        if ($('.wp-pagenavi a.first').length) {
            $('.wp-pagenavi a.first').insertAfter('.wp-pagenavi .previouspostslink');
        }

        if ($('.wp-pagenavi a.last').length) {
            $('.wp-pagenavi a.last').insertBefore('.wp-pagenavi .nextpostslink');
        }
    }
})(jQuery);
